module.exports = __webpack_public_path__ + "static/media/CTLI_5-235w.62393937.webp";